/* Copyright 2013 - 2024 Waiterio LLC */
import ApiError from '@waiterio/api-client/ApiError.js'

export default function failure(response) {
  throw new ApiError(response)
}
